import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { RegisterCreditProfilePayload } from '../credit-profile/types';
import type { CreditReport, CreditReportType } from './types';

export type GetCreditReportPayload = {
  creditProfileRegistrationId?: string;
};

const syncCreditReportPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<CreditReportType>>();
// The SSN re-entry refresh has not moved to registration flow IDs, so its payload still carries one.
export type RefreshedCreditReportPayload = RegisterCreditProfilePayload & {
  ssn?: string;
};

const refreshCreditReportPayloadCreator = getPayloadCreator<RegisterCreditProfilePayload>();
const getRefreshedCreditReportPayloadCreator = getPayloadCreator<RefreshedCreditReportPayload>();
const syncRefreshCreditReportPayloadCreator = getPayloadCreator<CreditReport>();
const getCreditReportPayloadCreator = (payload?: GetCreditReportPayload, meta?: unknown) => ({ payload, meta });

export const getCreditReport = createAction('GET_CREDIT_REPORT', getCreditReportPayloadCreator);
export const getCreditReportSuccess = createAction('GET_CREDIT_REPORT_SUCCESS', syncCreditReportPayloadCreator);
export const getCreditReportFailure = createAction('GET_CREDIT_REPORT_FAILURE', errorPayloadCreator);

export const refreshCreditReport = createAction('REFRESH_CREDIT_REPORT', refreshCreditReportPayloadCreator);
export const refreshCreditReportSuccess = createAction(
  'REFRESH_CREDIT_REPORT_SUCCESS',
  syncRefreshCreditReportPayloadCreator,
);
export const refreshCreditReportFailure = createAction('REFRESH_CREDIT_REPORT_FAILURE', errorPayloadCreator);

export const getRefreshedCreditReport = createAction(
  'GET_REFRESHED_CREDIT_REPORT',
  getRefreshedCreditReportPayloadCreator,
);
export const getRefreshedCreditReportSuccess = createAction(
  'GET_REFRESHED_CREDIT_REPORT_SUCCESS',
  syncRefreshCreditReportPayloadCreator,
);
export const getRefreshedCreditReportFailure = createAction('GET_REFRESHED_CREDIT_REPORT_FAILURE', errorPayloadCreator);

// A cached report outlives its registration when the profile is deleted elsewhere: nothing refetches
// it, since GET_CREDIT_REPORT only fires for a CREDIT_REPORT_RECEIVED profile.
export const clearOrphanedCreditReport = createAction('CLEAR_ORPHANED_CREDIT_REPORT', getPayloadCreator());
